import { render, staticRenderFns } from "./HOME_NOTIFICATIONS.vue?vue&type=template&id=40efc00d&scoped=true"
import script from "./HOME_NOTIFICATIONS.vue?vue&type=script&lang=ts"
export * from "./HOME_NOTIFICATIONS.vue?vue&type=script&lang=ts"
import style0 from "./HOME_NOTIFICATIONS.vue?vue&type=style&index=0&id=40efc00d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40efc00d",
  null
  
)

export default component.exports